import { getPageName } from "../../page/selectors";
import { CATEGORY_PAGE, SEARCH_PAGE } from "../../page/constants";
import { getCategoryId } from "../../category/selectors";
import { getSearchTerm } from "../../search/selectors";

export const addPageSpecificSearchParams = ({ url, state }) => {
  const pageNameSearchParamFactoryMap = {
    [CATEGORY_PAGE]: () => ["cid", getCategoryId(state)],
    [SEARCH_PAGE]: () => ["SearchQuery", getSearchTerm(state)]
  };
  const pageName = getPageName(state);
  const searchParamFactory = pageNameSearchParamFactoryMap[pageName];
  const output = new URL(url);

  if (searchParamFactory) {
    const [key, value] = searchParamFactory();
    output.searchParams.set(key, value);
  }

  return output.href;
};
